/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var LandingPageTypeEnum;

(function (LandingPageTypeEnum) {
  LandingPageTypeEnum["DEFAULT"] = "default";
  LandingPageTypeEnum["CUSTOM"] = "custom";
})(LandingPageTypeEnum || (LandingPageTypeEnum = {}));